import React from "react";
import cycleIllustration from "../../assets/illustrations/provider-beta/insight-relapse-cycle.png";

const HeroSection = ({ onPrimaryClick }) => (
  <header className="provider-beta__hero">
    <h1 className="provider-beta__hero-title">Support Your Clients Between Sessions</h1>
    <figure className="provider-beta__hero-figure">
      <img
        src={cycleIllustration}
        alt="From session insight through life stressors, returning old beliefs, and emotional reactions—a relapse loop between sessions"
        className="provider-beta__hero-image"
        width={1200}
        height={630}
        loading="eager"
        decoding="async"
      />
    </figure>
    <p className="provider-beta__hero-summary">
      Ahavibes is being designed as a structured reflection companion that helps people process
      experiences between sessions through guided reflection.
    </p>
    <div className="provider-beta__hero-actions">
      <button type="button" className="primary-button provider-beta__hero-cta" onClick={onPrimaryClick}>
        Apply as Provider Beta User
      </button>
    </div>
  </header>
);

export default HeroSection;
